import { normalizeImageWheelDelta } from "@/hooks/normalizeImageWheelDelta";
import { resolveWheelNavigation } from "@/hooks/resolveWheelNavigation";

interface WheelNavigationState {
  accumulatedX: number;
  accumulatedY: number;
  lastEventAt: number;
  navigated: boolean;
}

export function resolveImageWheelAction(
  previous: WheelNavigationState,
  event: {
    deltaX: number;
    deltaY: number;
    occurredAt: number;
    shiftKey: boolean;
  },
  canNavigate: boolean,
) {
  const { deltaX, deltaY } = normalizeImageWheelDelta(event);
  const navigation = resolveWheelNavigation(previous, {
    deltaX,
    deltaY,
    occurredAt: event.occurredAt,
  });
  const state = {
    ...navigation.state,
    navigated: canNavigate && navigation.state.navigated,
  };
  const continuesNavigationGesture = previous.navigated && navigation.state.navigated;
  const hasHorizontalIntent = Math.abs(deltaX) > Math.abs(deltaY);
  const handlesHorizontalGesture =
    hasHorizontalIntent || (canNavigate && continuesNavigationGesture);
  const navigationAction = canNavigate ? navigation.direction : null;
  const zoomAction =
    event.deltaY < 0 ? ("zoom-in" as const) : event.deltaY > 0 ? ("zoom-out" as const) : null;

  return { action: handlesHorizontalGesture ? navigationAction : zoomAction, state };
}
